import { createSvgIcon } from '@mui/material';

export const AlertCalendarOutlined = createSvgIcon(
  <>
    {/* eslint-disable-next-line @stylistic/max-len */}
    <path d='M20 3H19V1H17V3H7V1H5V3H4C2.9 3 2 3.9 2 5V21C2 22.1 2.9 23 4 23H20C21.1 23 22 22.1 22 21V5C22 3.9 21.1 3 20 3ZM20 21H4V10H20V21ZM20 8H4V5H20V8Z' />
    <path d='M13 17H11V19H13V17Z' />
    <path d='M13 11H11V16H13V11Z' />
  </>,
  'AlertCalendarOutlined',
);
